import { useEffect, useMemo } from "react";
import { useAppSelector } from "./useAppSelector";
import { eReducerStatusBase } from "../state/reducer-model/eReducerStatusBase";
import { useAppDispatch } from "./useAppDispatch";
import { rootActions } from "../state/actions/rootActions";
import { IDmChuyenNganh } from "../model/respone/category/IDmChuyenNganh";

export const useChuyenNganh = () => {
  const state = useAppSelector((x) => x.category.chuyenNganh);
  const { status, chuyenNganhs } = state;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (
      status === eReducerStatusBase.is_not_initialization ||
      status === eReducerStatusBase.is_need_reload
    ) {
      dispatch(rootActions.category.chuyenNganh.LOAD_START(undefined));
    }
  }, [dispatch, status]);
  const chuyenNganhMap = useMemo(() => {
    let _map = new Map<number, IDmChuyenNganh>();
    state.chuyenNganhs.forEach((chuyenNganh) =>
      _map.set(chuyenNganh.id_chuyen_nganh, chuyenNganh)
    );
    return _map;
  }, [state.chuyenNganhs]);
  return {
    ...state,
    chuyenNganhs,
    isLoading: status === eReducerStatusBase.is_loading,
    chuyenNganhMap,
  };
};
